module.exports = __webpack_public_path__ + "static/media/profile-picture-cover.4631946d.png";